import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Receipts from "@/pages/Receipts";
import ReceiptDetail from "@/pages/ReceiptDetail";
import QC from "@/pages/QC";
import Labels from "@/pages/Labels";
import Stock from "@/pages/Stock";
import Movements from "@/pages/Movements";
import StockCard from "@/pages/StockCard";
import ProductionReport from "@/pages/ProductionReport";
import Production from "@/pages/Production";
import Traceability from "@/pages/Traceability";
import Reports from "@/pages/Reports";
import MasterData from "@/pages/MasterData";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground">Memuat...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/receipts" element={<Protected><Receipts /></Protected>} />
      <Route path="/receipts/:id" element={<Protected><ReceiptDetail /></Protected>} />
      <Route path="/qc" element={<Protected><QC /></Protected>} />
      <Route path="/labels" element={<Protected><Labels /></Protected>} />
      <Route path="/stock" element={<Protected><Stock /></Protected>} />
      <Route path="/movements" element={<Protected><Movements /></Protected>} />
      <Route path="/stock-card" element={<Protected><StockCard /></Protected>} />
      <Route path="/production-report" element={<Protected><ProductionReport /></Protected>} />
      <Route path="/production" element={<Protected><Production /></Protected>} />
      <Route path="/production/:id" element={<Protected><Production /></Protected>} />
      <Route path="/traceability" element={<Protected><Traceability /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/master" element={<Protected><MasterData /></Protected>} />
      <Route path="/users" element={<Protected><Users /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
